import React from 'react'
import {useLocation} from 'wouter'
import {useController} from '@data-client/react'
import {apiReply, toast, useForm} from '../lib'
import {AppMsg, Field, ActionHeader, RequiredFieldNote, SubmitButton} from '../components'
import {useSearchParam} from 'react-use'
import {SignInResource} from '../lib/model'
import {SignInSchema} from '../lib/schema/Profile'
import {SignInForm} from '../lib/form/Profile'
import {Paper, Box, Container, Button} from '@mui/material'

interface MsgMap {
  out: string
  fail: string
  [propName: string]: string
}
const MSG: MsgMap = {
  out: 'signed out',
  fail: 'incorrect name or password',
}

export default function SignInPage() {
  const [location] = useLocation()
  localStorage.removeItem('session.scope')
  const form = useForm(SignInSchema)
  const [message, setMessage] = React.useState(MSG[String(useSearchParam('msg'))])
  const api = useController()

  /* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
  /* @ts-expect-error */
  const onSubmit = form.handleSubmit(async (data: SignInSchema) => {
    const msg = toast('loading', 'Logging In')
    const reply = await apiReply(() => api.fetch(SignInResource.create, data))
    if (reply.status === 401) {
      msg.remove()
      setMessage(MSG.fail)
      return
    } else if (reply.error) {
      msg.fail(reply.error)
      return
    }
    msg.succeed()
    if (location.startsWith('/signin')) {
      window.location.assign('/')
    } else {
      window.location.assign(location)
    }
  })

  return (
    <Container maxWidth="sm">
      <ActionHeader title="Sign In"/>
      {message && (
        <AppMsg severity="warning" size="medium">
          {message}
        </AppMsg>
      )}
      <Paper elevation={3} sx={{py: 3, px: 2}}>
        <RequiredFieldNote />
        <form onSubmit={onSubmit}>
          <Box my={5}>
            <Field form={form} attrs={SignInForm.name} />
          </Box>
          <Box my={5}>
            <Field form={form} attrs={SignInForm.password} />
          </Box>
          <Box mt={3} textAlign="center">
            <SubmitButton form={form}>Sign In</SubmitButton>
          </Box>
        </form>
        <Box display="flex" justifyContent="space-between" flexWrap="wrap" mt={3}>
          <Button href="/signup">Need an account?</Button>
          <Button href="/signin/reset">Forgot Password?</Button>
        </Box>
      </Paper>
    </Container>
  )
}
